import { Link } from "@tanstack/react-router";
import { Image } from "@/components/image";
import { DesktopNav } from "@/components/www/desktop-nav";
import { MobileNav } from "@/components/www/mobile-nav";
import { Footer } from "@/components/www/sections/footer";

export function NotFound() {
  return (
    <>
      <DesktopNav />
      <div className="relative grid min-h-svh place-items-center overflow-hidden bg-background px-4 py-16">
        <Image
          alt="Brick texture"
          className="-z-10 absolute top-0 left-0 w-1/4 opacity-30"
          height={220}
          src="/images/brick_texture.png"
          width={130}
        />
        <div className="relative z-10 mx-auto max-w-2xl text-center">
          <div className="mb-8 animate-fade-in">
            <h1 className="font-bold text-8xl text-primary md:text-9xl">404</h1>
            <div className="mx-auto mt-4 h-1 w-32 rounded-full bg-primary" />
          </div>

          <h2 className="mb-4 animate-fade-in font-bold text-3xl text-foreground [animation-delay:200ms] md:text-4xl">
            Seite nicht gefunden
          </h2>

          <p className="mb-12 animate-fade-in text-lg text-muted-foreground [animation-delay:400ms] md:text-xl">
            Die Seite, die Sie suchen, existiert leider nicht oder wurde
            verschoben. Kehren Sie zur Startseite zurück, um unsere Aktivitäten
            zu entdecken.
          </p>

          <Link
            className="inline-flex h-12 animate-fade-in items-center justify-center rounded-lg bg-primary px-8 font-semibold text-primary-foreground transition-all [animation-delay:600ms] hover:scale-105 hover:shadow-lg"
            to="/"
          >
            Zur Startseite
          </Link>
        </div>
      </div>
      <MobileNav />
      <Footer />
    </>
  );
}
